var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_530_92)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_530_92",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_530_92",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_530_92",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABxklEQVR4nO2aP0/CUBTFmd3YmVjUGCdjWEiAdxvioKMOwH2FBRMXcXNwYDQuzk58CXYXRxM+gXFSNzUuxjgcIxotSv/Q9r0W+k5yhjZNb349977ktc3ljIyMIgtt2gSL3XhtreoHkTSAJMRqFs9oVUvzDyITgMEEiLgH03VoS/E2CUNPn62rH4SpH+leTLeJJQPVILpgoAqE6RRMr9pgoArEpips2tIGA4Ug43O6YKAYRBsM1M3ICyQ9OvyudGnWsmq5e2BAlCbSttZh1zY8zeIi9YkEqsfUNyBeykwiaFYK6FAxlJuVQnpAWIwi7ElGBmRWZSaRuAUD4qPMJAIWQ7C4CemhD8jRAgy7OIsNIjkQES9EIJBWtQQmK5Sn7ALRoeLEsV1fgRT7ykFUCs3aMljcfdW2jucSBE6In/oRYHxbS9LJeDPkZWntzVTTrq+A6cFlrnpJDvt5pCTkX5gQyegEQRCIsDD+rSUOv19/ursldiK1k3RdvnupGvaZkpAhk9EC0t1eQqOc/2emA8fTv5p6TaOcTw2Ia+2WaDtALqPdbCFBZMRPb0FsU1cDiAbzb+oGRN8PAx6WtTUlrZWkYEBSJmQtkQ92QnEN2b1ZjwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.da1c269e6cdcbd372d955be7900df1c7.svg";
export { ForwardRef as ReactComponent };